import { LagoonSDK } from './lagoonSDK';
import { getLagoonEnv } from './helpers';
import { config } from '@uhg-abyss/web/tools/config';

const lagoonEnv = getLagoonEnv();
const ppdNamespace = 'sde-ppd';
const ppdSchema = {
  loadTables: {
    secure: config('ENABLE_SECURE_LAGOON'),
    unsecure: true,
  },
  loadForms: false,
};

export const ppdLagoon = new LagoonSDK(ppdNamespace, lagoonEnv, ppdSchema);
